import { render } from "./Pricing.vue?vue&type=template&id=a002c2f2&scoped=true"
import script from "./Pricing.vue?vue&type=script&lang=js"
export * from "./Pricing.vue?vue&type=script&lang=js"

import "./Pricing.vue?vue&type=style&index=0&id=a002c2f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a002c2f2"]])

export default __exports__